import script from "./LoginReserva.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginReserva.vue?vue&type=script&setup=true&lang=js"

import "./LoginReserva.vue?vue&type=style&index=0&id=268cdbf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268cdbf4"]])

export default __exports__